import React from "react";
import { useReportModal, useTrans } from "../hooks";
import { openResponsivePopup } from "../helpers";
import Icon from "./Icon";
import PropTypes from "prop-types";

const ReportStoryPart = ({ partId, storyId, storyTitle, author, language }) => {
  const { trans } = useTrans();
  const { openReportStoryModal } = useReportModal();

  const handleOnClick = () => {
    if (wattpad?.testGroups?.IS_NEW_REPORT_STORY_PART_FLOW) {
      openResponsivePopup({
        url: `/webview/report/storypart/${partId}`,
        width: 500,
        height: 700
      });
      return;
    }
    openReportStoryModal(storyId, storyTitle, author, language, partId);
  };

  return (
    <button className="btn-option" onClick={handleOnClick}>
      <Icon
        iconName="fa-warning"
        color="wp-neutral-2"
        height="20"
        className="pull-left"
      />
      {trans("Report Story")}
    </button>
  );
};

ReportStoryPart.propTypes = {
  partId: PropTypes.string.isRequired,
  storyId: PropTypes.string, // Marking as optional since it's not used in the new flow, but still needed for the old flow
  storyTitle: PropTypes.string,
  author: PropTypes.string,
  language: PropTypes.string
};

export default ReportStoryPart;
